module.exports = __webpack_public_path__ + "static/media/left-arrow-white.b929c45f.svg";